import { ReactNode } from "react"
import { Navigate } from "react-router-dom"

export const AdminOnly = ({ children }: { children: ReactNode }) => {
  const role = localStorage.getItem("role")

  if (role !== "admin") {
    return <Navigate to="/profile" replace />
  }

  return <>{children}</>
}
